import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver, useForm } from 'react-hook-form';
import { setLocale } from 'yup';
import { useTranslation } from 'react-i18next';

import { EventTask } from 'types';

export enum FIELDS {
  TITLE = 'title',
  ICON = 'icon',
}

export type EditCommunityTaskFormData = {
  [FIELDS.TITLE]: string;
  [FIELDS.ICON]: string;
};

export const useEditCommunityTaskForm = (eventTask: EventTask) => {
  const { t } = useTranslation();

  setLocale({
    mixed: { required: t('errors.required') },
    string: {
      min: ({ min }) => t('errors.min', { value: min }),
      max: ({ max }) => t('errors.max', { value: max }),
    },
  });

  const resolver: Resolver<EditCommunityTaskFormData> = yupResolver(
    yup.object().shape({
      [FIELDS.TITLE]: yup.string().required().max(50).min(3).trim(),
      [FIELDS.ICON]: yup.string().required(),
    }),
  );

  return useForm({
    resolver,
    defaultValues: eventTask || {
      [FIELDS.TITLE]: '',
      [FIELDS.ICON]: 'eye',
    },
  });
};
